var map = {
	"./lesson_6_1_a.pdf": 1235,
	"./lesson_6_1_b.pdf": 1236,
	"./lesson_6_2_a.pdf": 1237,
	"./lesson_6_2_b.pdf": 1238,
	"./lesson_6_4_a.pdf": 1239,
	"./lesson_6_4_b.pdf": 1240,
	"./lesson_6_4_c.pdf": 1241,
	"./lesson_6_4_d.pdf": 1242,
	"./lesson_6_4_e.pdf": 1243,
	"./lesson_6_5_a.pdf": 1244
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1234;